import "./PlayGame.scss";

import LeaderBoard from "./LeaderBoard/LeaderBoard";
import BackWebsite from "../components/shared/BackWebsite/BackWebsite";
import CurrentStats from "./CurrentStats/CurrentStats";
import GameLobby from "./Lobby/Lobby";
import { useSelector } from "react-redux";
import { RootState } from "../App/store";

export const PlayGame = () => {
  const userSelector = useSelector((state: RootState) => state.user);

  return (
    <div className="PlayGame">
      <div className="Container">
        <div className="Content">
          {userSelector.user?._id ? (
            <div className="Sections">
              <div className="Section">
                <div className="Section__header">Battle</div>
                <GameLobby></GameLobby>
              </div>
              <div className="Section">
                <div className="Section__header">LeaderBoard</div>
                <div className="Table">
                  <LeaderBoard></LeaderBoard>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="LayoutSnail">
            <img src="/assets/game/DashboardSnail.png" alt="" />
          </div>
        </div>
        <div className="BottomContainer">
          <CurrentStats></CurrentStats>
          <BackWebsite></BackWebsite>
        </div>
      </div>
    </div>
  );
};
export default PlayGame;
